import Modal from 'view-design/src/components/modal/modal.vue';
// import Button from 'view-design/src/components/button/button.vue';
import Locale from 'view-design/src/mixins/locale';

const prefixCls = 'ivu-modal-confirm';




let init = (Vue) => {




  Modal.newInstance = properties => {

    const _props = properties || {};

    let app = Vue.prototype.$app

    const Instance = new Vue({
      mixins: [Locale],
      data: _props,
      router: app.router.instance,
      store: app.store,
      render(h) {
        return h(Modal, {
          props: _props,
          on: {
            'on-cancel': this.cancel,
            'on-ok': this.ok
          }
        }, [this.render(h)])
      },
      methods: {
        cancel() {
          if (this.onCancel) this.onCancel();
          this.remove();
        },
        async ok() {

          try {

            if (this.closing) return;
            if (this.loading) {

            } else {
              this.$children[0].visible = false;
              this.remove();
            }
            if (this.onOk) await this.onOk();
          } finally {
            if (this.loading)
              modal.buttonLoading = false
          }
        },
        remove() {
          this.closing = true;
          setTimeout(() => {
            this.closing = false;
            this.destroy();
          }, 300);
        },
        destroy() {
          this.$destroy();
          if (this.$el) document.body.removeChild(this.$el);
          if (this.onRemove) this.onRemove();
        }
      }
    });

    const component = Instance.$mount();
    document.body.appendChild(component.$el);
    const modal = Instance.$children[0];

    return {
      show() {
        modal.visible = true;
      },
      remove() {
        modal.visible = false;
        modal.$parent.remove();
      },
      component: modal
    };
  };



  Vue.prototype.$Modal2 = {

    create(options) {

      let instance = Modal.newInstance(Object.assign({
        closable: false,
        maskClosable: false,
        footerHide: false,
        // fullscreen: true,
        lockScroll: true
      }, options));


      return instance
    }

  }








}















export default init